import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=ca6f94ae"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=ca6f94ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports